module.exports = __webpack_public_path__ + "static/img/2_2.bd659f96.jpg";